module.exports = __webpack_public_path__ + "static/media/rightBlackarrow.efdd9689.svg";